const editMyPageProps = {
  user: {
    id: 1,
    name: '황인서',
    nickName: 'sjsjsj1246',
    email: 'test@gmail.com',
    token: null,
    weight: 50,
    height: 190,
    image: '',
  },
};

export default editMyPageProps;
